const SESSION_UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isSessionUuid(value: string | null | undefined): value is string {
  return typeof value === 'string' && SESSION_UUID_RE.test(value);
}
